import { render, staticRenderFns } from "./newcomer-campaign.vue?vue&type=template&id=58821ed9&scoped=true"
import script from "./newcomer-campaign.vue?vue&type=script&lang=js"
export * from "./newcomer-campaign.vue?vue&type=script&lang=js"
import style0 from "./newcomer-campaign.vue?vue&type=style&index=0&id=58821ed9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58821ed9",
  null
  
)

export default component.exports